import React from "react";
import {
    Button,
    Container,
    Header
} from "semantic-ui-react";
import { withRouter } from "react-router";
import logo from "../../images/logo/logo-full-black.png";
import { dispatch } from "@rematch/core";
import LoadingComponent from "./LoadingComponent";

class NoAssociatedAccount extends React.Component {
    state = {
        step: 1,
        selectedRole: "",
        selectedIndustry: "",
        selectedCompanySize: "",
        errors: {},
        loading:false
    };

    handleNext = () => {
        const { step } = this.state;
        if (this.validateStep(step)) {
            if (step === 3) {
                this.handleSubmit();
            } else {
                this.setState((prevState) => ({
                    step: prevState.step + 1,
                    errors: {}
                }));
            }
        }
    };

    handleBack = () => {
        this.setState((prevState) => ({
            step: Math.max(prevState.step - 1, 1),
            errors: {}
        }));
    };

    handleInputChange = (field, value) => {
        this.setState({ [field]: value, errors: { ...this.state.errors, [field]: "" } });
    };

    validateStep = (step) => {
        const { selectedRole, selectedIndustry, selectedCompanySize } = this.state;
        const errors = {};

        if (step === 1 && !selectedRole) {
            errors.selectedRole = "Please select a role.";
        }
        if (step === 2 && !selectedIndustry) {
            errors.selectedIndustry = "Please select an industry.";
        }
        if (step === 3 && !selectedCompanySize) {
            errors.selectedCompanySize = "Please select size of your company.";
        }

        this.setState({ errors });
        return Object.keys(errors).length === 0;
    };

    handleSubmit = async () => {
        this.setState({loading:true})
        const { selectedRole, selectedIndustry, selectedCompanySize } = this.state;
        const accountUserData = {
            role: selectedRole,
            industry: selectedIndustry,
            companySize: selectedCompanySize
        };
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
       await dispatch.account.createAccount({email:this.props.match.params.useremail,timeZone,accountUserData});
       this.setState({loading:false})
    };

    render() {
        const { step, selectedRole, selectedIndustry, selectedCompanySize, errors } = this.state;
        //const roles = ["Sales", "Marketing", "Agency", "Operations", "Engineering", "Product", "Finance", "Design"];
        const roles = ["Sales", "Marketing", "Project Management Office", "Operations", "Engineering", "Consultant", "Finance", "Designer","AI / Automations"];
        //const industries = ["Software/Tech", "Professional Services", "Real Estate", "Financial Services", "Healthcare", "Construction", "Retail/E-Commerce", "Manufacturing"];
        const industries = ["Technology / Software", "Consulting / Agency", "Real Estate", "FinTech", "Health Care", "Government", "Transportation", "Education","Retail / E-Commerce"];
        const companySize = ["1-5", "6-25", "26-100","101-1000", "1000+"];
        const totalSteps = 3;
        const progressPercentage = (step / totalSteps) * 100;

        return (
            <div className="backgroundCss">
                <LoadingComponent active={this.state.loading} message="Creating Your Account..." />
                <Container className="pad_40 bg-white">
                    <Header style={{ margin: '10px' }} textAlign='center'>
                        <img src={`${logo}`} alt="Logo" style={{ width: '150px', height: 'auto' }} />
                    </Header>
                     <div style={{ marginTop: '30px', fontSize: "24px", textAlign: "center" }}>
                        <b>Welcome to Aspenify</b>
                    </div><br></br>
                    {/* <div className='text-muted' style={{ display: "flex", justifyContent: "center", marginTop: '10px', fontSize: "10px" }}>
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: '10px', fontSize: "10px" }}>
                        <div style={{ height: '6px', backgroundColor: '#f3f3f3', borderRadius: '5px', width: "400px" }}>
                            <div
                                style={{
                                    width: `${progressPercentage}%`,
                                    height: '100%',
                                    backgroundColor: '#3b82f6',
                                    borderRadius: '5px',
                                    transition: 'width 0.3s ease'
                                }}
                            />
                        </div>
                    </div>  */}
                    {step === 1 && (
                        <div>
                            <div style={{ width: "400px", marginLeft: "320px" }}>
                                <b className="text-bold-large" style={{ fontWeight: "normal", margin: 0 }}>
                                    Take a few minutes to tell us about your team or project.
                                </b>
                            </div>
                            <div style={{ width: "450px", marginLeft: "290px",marginTop:"3px" }}>
                                <b className="text-bold-large" style={{ fontWeight: "normal", margin: 0 }}>
                                    This info will help us streamline prompts and template libraries.
                                </b>
                            </div><br></br>
                            <div className='text-muted' style={{ display: "flex", justifyContent: "center", marginTop: '10px', fontSize: "10px" }}></div>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: '10px', fontSize: "10px" }}>
                                    <div style={{ height: '6px', backgroundColor: '#f3f3f3', borderRadius: '5px', width: "400px" }}>
                                        <div
                                            style={{
                                                width: `${progressPercentage}%`,
                                                height: '100%',
                                                backgroundColor: '#3b82f6',
                                                borderRadius: '5px',
                                                transition: 'width 0.3s ease'
                                            }}
                                        />
                                    </div>
                                </div>
                                <div style={{ marginTop: '20px', fontSize: "24px", textAlign: "center" }}>
                                   <b>What role best describes you?</b>
                                </div>
                            <div className="rolesGrid">
                                {roles.map((role, index) => (
                                    <div
                                        className={`roleBox ${selectedRole === role ? "selected" : ""}`}
                                        key={index}
                                        onClick={() => this.handleInputChange("selectedRole", role)}
                                    >
                                        {role}
                                    </div>
                                ))}                              
                                 <div className={`roleBox ${!roles.includes(selectedRole) && selectedRole ? "selected" : ""}`} style={{gridColumn: "2 / 3",}}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
                                        <i className="search icon" style={{ fontSize: '16px' }}></i>
                                        <input
                                            type="text"
                                            placeholder="Other"
                                            value={!roles.includes(selectedRole) ? selectedRole : ""}
                                            onChange={(e) => this.handleInputChange("selectedRole", e.target.value)}
                                            style={{
                                                border: 'none',
                                                outline: 'none',
                                                padding: '5px',
                                                fontSize: '14px',
                                                width: '100%',
                                                color: selectedRole && !roles.includes(selectedRole) ? 'white' : 'black',
                                                backgroundColor: 'transparent',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            {errors.selectedRole && <div style={{color:"red",textAlign:"center",marginTop: "10px", fontSize:"14px"}}>{errors.selectedRole}</div>}
                        </div>
                    )}
                    {step === 2 && (
                        <div>

                            <div style={{ width: "400px", marginLeft: "320px" }}>
                                <b className="text-bold-large" style={{ fontWeight: "normal", margin: 0 }}>
                                    Take a few minutes to tell us about your team or project.
                                </b>
                            </div>
                            <div style={{ width: "450px", marginLeft: "290px",marginTop:"3px" }}>
                                <b className="text-bold-large" style={{ fontWeight: "normal", margin: 0 }}>
                                    This info will help us streamline prompts and template libraries.
                                </b>
                            </div><br></br>
                            <div className='text-muted' style={{ display: "flex", justifyContent: "center", marginTop: '10px', fontSize: "10px" }}></div>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: '10px', fontSize: "10px" }}>
                                    <div style={{ height: '6px', backgroundColor: '#f3f3f3', borderRadius: '5px', width: "400px" }}>
                                        <div
                                            style={{
                                                width: `${progressPercentage}%`,
                                                height: '100%',
                                                backgroundColor: '#3b82f6',
                                                borderRadius: '5px',
                                                transition: 'width 0.3s ease'
                                            }}
                                        />
                                    </div>
                                </div>
                            <div style={{ marginTop: '30px', fontSize: "24px", textAlign: "center" }}>
                                <b>What industry do you work in?</b>
                            </div>
                            <div className="rolesGrid">
                                {industries.map((industry, index) => (
                                    <div
                                        className={`roleBox ${selectedIndustry === industry ? "selected" : ""}`}
                                        key={index}
                                        onClick={() => this.handleInputChange("selectedIndustry", industry)}
                                    >
                                        {industry}
                                    </div>
                                ))}
                                <div className={`roleBox ${!industries.includes(selectedIndustry) && selectedIndustry ? "selected" : ""}`} style={{gridColumn: "2 / 3",}}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} >
                                        <i className="search icon" style={{ fontSize: '16px' }}></i>
                                        <input
                                            type="text"
                                            placeholder="Other"
                                            value={!industries.includes(selectedIndustry) ? selectedIndustry : ""}
                                            onChange={(e) => this.handleInputChange("selectedIndustry", e.target.value)}
                                            style={{
                                                border: 'none',
                                                outline: 'none',
                                                padding: '5px',
                                                fontSize: '14px',
                                                width: '100%',
                                                color: selectedIndustry && !industries.includes(selectedIndustry) ? 'white' : 'black',
                                                backgroundColor: 'transparent',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            {errors.selectedIndustry && <div style={{color:"red",textAlign:"center",marginTop: "10px", fontSize:"14px"}}>{errors.selectedIndustry}</div>}
                        </div>
                    )}
                    {step === 3 && (
                        <div>
                            <div style={{width:"350px", marginLeft:"350px"}}>
                                <b className="text-bold-large">How many people are you working with?</b>
                            </div><br></br>
                            <div className='text-muted' style={{ display: "flex", justifyContent: "center", marginTop: '10px', fontSize: "10px" }}></div>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: '10px', fontSize: "10px" }}>
                                    <div style={{ height: '6px', backgroundColor: '#f3f3f3', borderRadius: '5px', width: "400px" }}>
                                        <div
                                            style={{
                                                width: `${progressPercentage}%`,
                                                height: '100%',
                                                backgroundColor: '#3b82f6',
                                                borderRadius: '5px',
                                                transition: 'width 0.3s ease'
                                            }}
                                        />
                                    </div>
                                </div>
                            <div style={{ marginTop: '30px', fontSize: "24px", textAlign: "center" }}>
                                {/* <b>How Big Is Your Company?</b> */}
                                <b>How big is your team,community or organization?</b>
                            </div>
                            <div style={{ height: "190px", display: "flex", justifyContent: "center", gap: "20px", marginTop: "30px" }}>
                                {companySize.map((size, index) => (
                                    <div
                                        className={`roleBox ${selectedCompanySize === size ? "selected" : ""}`}
                                        style={{ width:"150px" }}
                                        key={index}
                                        onClick={() => this.handleInputChange("selectedCompanySize", size)}
                                    >
                                        {size}
                                    </div>
                                ))}
                            </div>
                            {errors.selectedCompanySize && <div style={{color:"red",textAlign:"center",marginTop: "10px", fontSize:"14px"}}>{errors.selectedCompanySize}</div>}
                        </div>
                    )}
                    <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "30px" }}>
                        {step > 1 && (
                            <Button className="button-cancel float-right mar_0" onClick={this.handleBack}>
                                Back
                            </Button>
                        )}
                        <Button className="button-submit float-right mar_0" onClick={this.handleNext}>
                            {step === 3 ? "Submit" : "Next"}
                        </Button>
                    </div>
                </Container>
            </div>
        );
    }
}

export default withRouter(NoAssociatedAccount);
